<template>
	<div class="banner">
		<div class="container">
			<div class="row banner-text">
				<div class="slider-info col-lg-6">
					<div class="agileinfo-logo pl-2">
						<h2>软件编程 </h2>
						<h4>全国青少年软件编程等级考试</h4>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 高校参与制定标准和人才招生选拔体系</p>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 采用国际通行的开源C/Python等编程语言</p>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 锻炼青少年逻辑思维能力和良好的学习习惯</p>
					</div>
					<a @click="to1" class="btn mr-3 text-capitalize ml-2" href="javascript:void(0)">考试测评</a>
					<a @click="to2" class="btn mr-3 text-capitalize" href="javascript:void(0)">行业新闻</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CppBanner',
		methods: {
			to1() {
				this.$router.push({
					path: '/cpp/test'
				})
			},
			to2() {
				this.$router.push({
					path: '#'
				})
			}
		},
		mounted() {}
	}
</script>
<style lang="scss" scoped>
	@import '@/assets/css/robot/components/RobotBanner.scss';
</style>